import styled, { css } from 'styled-components';
import { ColumnValues } from './../../Components/BalanceDetailsTable/styles.js';
import { CommonTable } from '../../../../CommonComponents/commonStyles';
import { styleConfig } from './styleConfig';

export const ColumnValuesBlue = styled(ColumnValues)`
  color: ${(props) => props.theme.fontColors.primary};
  text-decoration: underline;
  cursor: pointer;
`;

export const EmptyMessage = styled.p`
  font-family: ${(props) => props.theme.fontFamily.berkeleyStdMedium};
  font-size: ${(props) => props.theme.fontSize.h4};
  color: ${(props) => props.theme.fontColors.textColor};
  line-height: 1.5;
`;

export const TableData = styled.div`
  word-break: ${(props) =>
    props.break ? (props.ie ? 'break-all' : 'break-word') : 'normal'};
  font-size: 15px;
`;

const transactionMixin = (selector = '', styles) => {
  if (styles && selector) {
    return css`
      &.${selector} .ant-table-thead .ant-table-header-column {
        width: ${styles.defaultWidth}px;
      }
      
      &.${selector} .ant-table-tbody .ant-table-row td div{
        width: ${styles.defaultWidth}px;
      }

      ${styles.customStyles
        .map((style) => {
          return `
            ${
              style.sorterPos
                ? `&.${selector} .ant-table-thead th:nth-child(${style.column}) .ant-table-header-column .ant-table-column-sorter {
                  left: ${style.sorterPos}px !important;
                }`
                : ''
            }        

            &.${selector} .ant-table-thead th:nth-child(${
            style.column
          }) .ant-table-header-column {
              width: ${style.width}px;     
            }
      
            &.${selector} .ant-table-thead th:nth-child(${
            style.column
          }) .ant-table-header-column .ant-table-column-title {
              width: ${style.width}px;
              text-align: ${style.textAlign};
            }

            &.${selector} .ant-table-row td:nth-child(${style.column}) div{
              width: ${style.width}px;
              text-align: ${style.textAlign};
            }
          `;
        })
        .join('')} 
    `;
  }

  return;
};

export const TransactionTable = styled(CommonTable)`
  margin-bottom: 40px;

  .ant-table-header {
    overflow: hidden !important;
  }

  .ant-table-body {
    overflow-x: hidden !important;
  }

  &.tansactionTableWrapper .ant-table-body {
    border-top: 1px solid #eaeaea !important;
  }

  &.tansactionTableWrapper .ant-table-header table {
    padding-right: ${(props) => (props.ie ? '17px' : '6px')};
  }

  &.tansactionTableWrapper .ant-table-body::-webkit-scrollbar {
    width: 10px;
  }

  &.tansactionTableWrapper .ant-table-body::-webkit-scrollbar-thumb {
    background: rgba(0, 103, 120, 0.6);
    border-radius: 5px;
  }

  &.tansactionTableWrapper .ant-table-column-title {
    max-width: none;
  }

  &.tansactionTableWrapper .ant-table-header-column {
    position: relative;
  }

  &.tansactionTableWrapper .ant-table-header-column .ant-table-column-sorter {
    left: -13px;
  }

  ${(props) => {
    const tableClassName = props.className ? props.className.split(' ')[1] : '';

    return css`
    @media screen and (min-width: 1101px) {
        ${transactionMixin(
          tableClassName,
          styleConfig.desktop[tableClassName]
        )};
    
      @media screen and (max-width: 1100px) {
        ${transactionMixin(
          tableClassName,
          styleConfig.ipadPro[tableClassName]
        )};
      }`;
  }}
`;
